// ============================================
// Path: /frontend/src/api/contacts.api.js
// Purpose: Contact form API endpoints
// ============================================

import apiClient from './client.js';

export const contactsAPI = {
  // Get all contacts (admin only)
  getAllContacts: async () => {
    console.log('[contactsAPI] Fetching all contacts (admin)');
    try {
      const response = await apiClient.get('/contacts');
      console.log('[contactsAPI] Fetched', response.data.contacts?.length || 0, 'contacts');
      return response.data;
    } catch (error) {
      console.error('[contactsAPI] Error fetching contacts:', error);
      throw error;
    }
  },

  // Submit contact form
  submitContact: async (contactData) => {
    console.log('[contactsAPI] Submitting contact form:', contactData.subject);
    try {
      const response = await apiClient.post('/contacts', contactData);
      console.log('[contactsAPI] Contact form submitted successfully');
      return response.data;
    } catch (error) {
      console.error('[contactsAPI] Error submitting contact form:', error);
      throw error;
    }
  },

  // Delete contact (admin only)
  deleteContact: async (id) => {
    console.log('[contactsAPI] Deleting contact:', id);
    try {
      const response = await apiClient.delete(`/contacts/${id}`);
      console.log('[contactsAPI] Contact deleted successfully');
      return response.data;
    } catch (error) {
      console.error('[contactsAPI] Error deleting contact:', error);
      throw error;
    }
  },
};
